// src/pages/ViewPackaging.js
import React, { useEffect, useState } from "react";
import { useAuthCheck } from "../components/Auth";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../components/Api";
import Loading from "../components/Loading";

export default function ViewPackaging() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [packaging, setPackaging] = useState(null);
    const [loading, setLoading] = useState(true);
    const [quantityToAdd, setQuantityToAdd] = useState("");
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    useEffect(() => {
        const fetchPackaging = async () => {
            setLoading(true);
            try {
                const res = await api.get(`/packaging/${id}`);
                setPackaging(res.data);
            } catch (err) {
                console.error(err);
                alert("Erreur lors de la récupération du packaging.");
            } finally {
                setLoading(false);
            }
        };

        fetchPackaging();
    }, [id]);

    const handleAddQuantity = async () => {
        const qty = parseInt(quantityToAdd);
        if (!qty || qty < 1) {
            alert("Veuillez saisir un nombre valide supérieur à 0.");
            return;
        }

        try {
            const res = await api.put(`/packaging/${id}`, { quantity_to_add: qty });
            alert(`Nouvelle quantité : ${res.data.packaging_quantity}`);
            setQuantityToAdd("");
            const updated = await api.get(`/packaging/${id}`);
            setPackaging(updated.data);
            navigate(`/packaging-list`);
        } catch (err) {
            console.error(err);
            alert("Erreur lors de la mise à jour de la quantité.");
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    if (loading) return <Loading message="Chargement du packaging..." />;
    if (!packaging) return <p>Packaging introuvable.</p>;

    return (
        <div className="container mx-auto p-6">

            <h1 className="text-2xl font-bold mb-4 dark:text-white">{packaging.packaging_name}</h1>

            <div className="mb-4">
                <div><strong>Dimension :</strong> {packaging.packaging_dimension}</div>
                <div><strong>Poids (g) :</strong> {packaging.packaging_weight}</div>
                <div><strong>Quantité :</strong> {packaging.packaging_quantity}</div>
            </div>

            <div className="flex items-center space-x-2">
                <input
                    type="number"
                    min="1"
                    value={quantityToAdd}
                    onChange={(e) => setQuantityToAdd(e.target.value)}
                    placeholder="Quantité à ajouter"
                    className="border p-2 rounded w-48"
                />
                <button
                    onClick={handleAddQuantity}
                    className="bg-green-400 hover:bg-green-500 text-white px-4 py-2 rounded"
                >
                    Ajouter
                </button>
            </div>
        </div>
    );
}
